import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios'

import {Url} from '../../url/url'

export const productdata =  createAsyncThunk('productdata', async ()=>{
    const response = await axios.get(`${Url}/product`).then(data => data.data) 
    // console.log("response response productData", response);
    
     return response 
    //  return response.data 

  })

const ProductSlice = createSlice({
    name: "product data",
    initialState: { 
        isLoading: false,
        data: [],
        totalCount : 0,
        totalPages : 1,
        currentPage : 1
    },
    extraReducers: (builder)=>{
        builder.addCase(productdata.pending, (state,action)=>{
          state.isLoading = true;
        })
    
      builder.addCase(productdata.fulfilled, (state,action)=>{
        state.isLoading = false; 
        state.data = action.payload.data; 
        state.totalCount = action.payload.totalCount; 
        state.totalPages = action.payload.totalPages; 
        state.currentPage = action.payload.currentPage; 

      });
      builder.addCase(productdata.rejected, (state,action)=>{ 
        state.isError=true;
      })
    }
})
 
export default ProductSlice.reducer;


 



